import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Footer() {
  const { FiFacebook, FiYoutube, FiInstagram, FiLinkedin } = FiIcons;

  const socialLinks = [
    { Icon: FiFacebook, href: 'https://www.facebook.com/profitlenseai' },
    { Icon: FiYoutube, href: 'https://www.youtube.com/@ProfitLenseai' },
    { Icon: FiInstagram, href: 'https://www.instagram.com/profitlense_ai/' },
    { Icon: FiLinkedin, href: 'https://www.linkedin.com/company/profitlense-ai/' }
  ];
  
  return (
    <footer className="border-t border-white/5 py-16 md:py-24 bg-[#0A1628] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 flex flex-col items-center relative z-10">
        <div className="mb-12 md:mb-16 group cursor-pointer text-center">
          <img 
            src="https://i.postimg.cc/PJHcFz0Z/Profit-Lense-Ai-removebg-preview.png" 
            alt="ProfitLense.ai" 
            className="h-20 md:h-36 w-auto object-contain mx-auto transition-transform duration-300 group-hover:scale-105" 
          />
        </div>

        <div className="flex items-center gap-8 md:gap-12 mb-12 md:mb-16">
          {socialLinks.map(({ Icon, href }, i) => (
            <a 
              key={i} 
              href={href} 
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#B8C8E8] hover:text-[#1E90FF] transition-all transform hover:scale-125 hover:-translate-y-1"
            >
              <SafeIcon icon={Icon} className="text-2xl md:text-3xl" />
            </a>
          ))}
        </div>

        <p className="text-[#B8C8E8]/60 text-sm md:text-base mb-10 font-medium tracking-wide text-center max-w-md">
          © {new Date().getFullYear()} ProfitLense.ai — Precision AI Trading Platform. All rights reserved.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 text-[10px] md:text-[11px] text-[#B8C8E8]/40 font-bold uppercase tracking-[0.3em] px-4 text-center">
          <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
          <span className="hidden md:inline text-white/10">•</span>
          <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          <span className="hidden md:inline text-white/10">•</span>
          <a href="#" className="hover:text-white transition-colors">Risk Disclosure</a>
        </div>
      </div>

      {/* Aesthetic bottom glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-4/5 md:w-1/2 h-1 bg-gradient-brand blur-xl opacity-30"></div>
    </footer>
  );
}